import React, { useEffect,useState } from 'react';
import axios from 'axios';

export default function Dashboard(){
    const [totalSites,setTotalSites] = useState('~');
    const [totalCust,setTotalCust] = useState('~');
    const [totalBookingAmount,setTotalBookingAmount] = useState('~');
    useEffect(() => {
        getData();
    },[])
    function getData(){
        axios.get('https://vdcserver.herokuapp.com/api/dashboard/count')
        .then((resp) => {
            setTotalSites(resp.data[0]['count(*)']);
            setTotalCust(resp.data[1]['count(*)']);
            setTotalBookingAmount(resp.data[2]['count(*)'])
        })
        .catch((err) => {
            console.log(err);
        })
    }
    return(
        <>
        <div className='parentGrid'>
            <div>
            <h1>{totalSites}</h1> <p>Total Properties</p>
            </div>
            <div>
            <h1>{totalCust}</h1> <p>Total Customers</p>
            </div>
            <div>
            <h1>{totalBookingAmount}</h1>  <p>Total Booking Amount Received</p>
            </div>
        </div>
        </>
    )
}